module.exports = __webpack_public_path__ + "static/media/English - Teaching - Words - translated by JL.47ae49c1.txt";